import {t} from 'i18next'
import {Button} from 'primereact/button'
import {FileUpload} from 'primereact/fileupload'
import {Tag, TagSeverityType} from 'primereact/tag'
import React, {Fragment, useRef, useState} from 'react'

export const chooseOptions = {
	icon: 'fas fa-folder-open',
	label: t<string>('core.file_explorer'),
	className: 'p-button-rounded p-button-outlined p-button mr-2 '
}

export const uploadOptions = {
	icon: 'fas fa-cloud-upload-alt',
	label: t<string>('core.upload_button'),
	className: 'p-button-rounded p-button-outlined mr-2'
}

export const cancelOptions = {
	icon: 'fa-solid fa-trash',
	iconOnly: true,
	tooltip: t<string>('core.remove'),
	className: 'p-button-text p-button-danger'
}

export const MokaiUpload = (props: {
	allowMultiple: boolean,
	showUploadButton: boolean,
	allowedTypes: string,
	maxFileSize: number,
	uploadHandler: (event: any) => Promise<any | undefined>,
	failHandler: (event: any) => void
})
	: JSX.Element => {

	const fileUploadRef = useRef<FileUpload>(null)

	const [validDropArea, setValidDropArea] = useState<boolean>(false)
	const emptyTemplate = (): JSX.Element => {
		return (
			<div
				onDragEnter={() => {
					setValidDropArea(true)
				}}
				onDragLeave={() => {
					setValidDropArea(false)
				}}
				className={`flex align-items-center pl-2 pr-2 pt-3 mt-1 pb-3 mb-1 drag-and-drop 
                    ${validDropArea ? 'drag-hover' : ''}`}
			>
				<i
					className="fas fa-file-upload mt-1 icon-blue mr-2"
					style={{'fontSize': '3em'}}
				/>
				<span
					style={{'fontSize': '1em'}}
					className="w-full secondary-text">{t<string>('core.drag_and_drop')}</span>
			</div>
		)
	}

	const onTemplateRemove = (file: any, callback: any) => {
		//setTotalSize(totalSize - file.size);
		callback()
	}

	const itemTemplate = (file: any, properties: any): JSX.Element => {

		let severity = 'info'
		if (properties.formatSize > 10000) {
			severity = 'warning'
		}
		if (properties.formatSize > props.maxFileSize) {
			severity = 'error'
		}

		const fileExt = file.name?.split('.').pop()?.toLowerCase()
		let icon
		switch (fileExt) {
			case 'pdf':
				icon = <i className={'fas fa-file-pdf fa-lg icon-orange avatar center-icon'}/>
				break
			case 'doc':
			case 'docx':
				icon = <i className={'fas fa-file-word fa-lg icon-blue avatar center-icon'}/>
				break
			case 'xsl':
			case 'xslt':
			case 'xlsx':
			case 'csv':
				icon = <i className={'fas fa-file-excel fa-lg icon-green avatar center-icon'}/>
				break
			case 'zip':
				icon = <i className={'fas fa-file-archive fa-lg icon-orange avatar center-icon'}/>
				break
			case 'pptx':
			case 'ppt':
				icon = <i className={'fas fa-file-powerpoint fa-lg icon-orange avatar center-icon'}/>
				break
			case 'txt':
			case 'log':
				icon = <i className={'fas fa-file-alt fa-lg icon-gray avatar center-icon'}/>
				break
			case 'json':
			case 'html':
			case 'ps1':
			case 'java':
			case 'py':
			case 'cs':
			case 'ps2':
			case 'css':
			case 'js':
				icon = <i className={'fas fa-file-code fa-lg icon-dark-gray avatar center-icon'}/>
				break
			default:
				icon = <img alt={''} role="presentation" src={file.objectURL} className={'avatar'}/>
		}
		return (
			<Fragment>
				<div className="flex" style={{width: '40%'}}>
					{icon}
					<span className="text-left p-ml-2">
						{file.name}
					</span>
				</div>
				<Tag value={properties.formatSize} severity={severity as TagSeverityType} className="px-3 py-2 mr-2"/>
				<Button
					type="button"
					icon="pi pi-times"
					className="p-button-danger p-button-text"
					onClick={() => onTemplateRemove(file, properties.onRemove)}/>
			</Fragment>
		)
	}

	const headerTemplate = (options: any) => {
		const {className, chooseButton, uploadButton, cancelButton} = options

		return (
			<div key="upload" className={className} style={
				{backgroundColor: 'transparent', display: 'flex', alignItems: 'center'}
			}>
				{chooseButton}
				{props.showUploadButton && uploadButton}
				{cancelButton}
			</div>
		)
	}

	return <FileUpload
		ref={fileUploadRef}
		name="mokaiFiles[]"
		customUpload={true}
		headerTemplate={headerTemplate}
		chooseOptions={chooseOptions}
		uploadOptions={uploadOptions}
		cancelOptions={cancelOptions}
		emptyTemplate={emptyTemplate}
		itemTemplate={itemTemplate}
		contentStyle={{backgroundColor: 'rgb(226, 227,227)'}}
		uploadHandler={props.uploadHandler}
		multiple={props.allowMultiple}
		onValidationFail={props.failHandler}
		accept={props.allowedTypes}
		maxFileSize={props.maxFileSize}
	/>

}